var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgQuizTickIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1C4.365 1 1 4.365 1 8.5S4.365 16 8.5 16 16 12.635 16 8.5 12.635 1 8.5 1zm0 14.423A6.931 6.931 0 0 1 1.577 8.5 6.931 6.931 0 0 1 8.5 1.577 6.931 6.931 0 0 1 15.423 8.5 6.931 6.931 0 0 1 8.5 15.423z",
    fill: "#239A59",
    stroke: "#239A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.034 5.424 7.6 10.412 4.93 8.274a.291.291 0 0 0-.397.053.287.287 0 0 0 .037.398l2.885 2.308A.287.287 0 0 0 7.85 11l4.616-5.192a.29.29 0 0 0-.277-.473.285.285 0 0 0-.155.09z",
    fill: "#239A59",
    stroke: "#239A59"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuizTickIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/quiz-tick-icon.f842a2b2.svg";
export { ForwardRef as ReactComponent };